<template>
  <div style="height: 100%; background: #F2F2F6">
         <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'Version' }">硬件列表</el-breadcrumb-item>
          <el-breadcrumb-item>硬件维护</el-breadcrumb-item>
        </el-breadcrumb>
    <el-row style="padding: 30px">
      <el-col :span="12" >
        <el-form
          :model="version"
          :rules="rules"
          ref="versionForm"
          label-width="150px"
          label-position="right"
          size="mini"
        >
           <el-form-item label="名称" prop="name">
            <el-input v-model="version.name" maxlength="45"></el-input>
          </el-form-item>
          <el-form-item label="Format" prop="format">
            <el-input v-model="version.format" maxlength="20" ></el-input>
          </el-form-item>
         <el-form-item label="Fota Type" prop="fotaType">
            <el-input v-model="version.fotatype" maxlength="20" placeholder="fota指令中的type参数"></el-input>
          </el-form-item>
          <el-form-item label="固件版本" prop="version">
            <el-input v-model="version.version" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="硬件类型" prop="type">
            <el-select v-model="version.type" placeholder="请选择">
              <el-option label="4G网关" :value="'4G网关'"></el-option>
              <el-option label="线控器" :value="'线控器'"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="海外/全球通" prop="global">
            <el-select v-model="version.global" placeholder="请选择">
              <el-option label="否" :value="0"></el-option>
              <el-option label="是" :value="1"></el-option>
            </el-select>
          </el-form-item>
            <el-divider></el-divider>
          <el-form-item>
            <el-button type="primary" @click="save()">保存</el-button>
            <el-button @click="back()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'CreateUser',
  data () {
    return {
      version: {
        name: '',
        format: '',
        fotatype: '',
        type: '4G网关',
        global: 0,
        version: ''
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        fotatype: [{ required: true, message: '请输入Fota协议中的type', trigger: 'blur' }],
        version: [{ required: true, message: '请输入固件版本号', trigger: 'blur' }]
      }
    }
  },
  mounted: function () {
    let user = window.localStorage.getItem('customer')
    if (user) {
      if (this.$route.params.innerid) {
        var self = this
        Vue.axios
          .post('/version/query', {
            innerid: this.$route.params.innerid
          })
          .then((res) => {
            if (res.data.errcode == 0) {
              self.version = res.data.msgbody
            } else {
              this.$message({
                showClose: true,
                message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
                type: 'error'
              })
            }
          })
      }
    } else {
      this.$message({
        message: '无登录信息，请重新登录',
        type: 'warning'
      })
      this.$router.push({ name: 'Login' })
    }
  },
  methods: {
    save () {
      this.$refs.versionForm.validate((valid) => {
        if (valid) {
          var self = this
          let url = '/version/add'
          if (self.$route.params.innerid) {
            url = '/version/edit'
          }
          Vue.axios
            .post(url,
              self.version
            )
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.$router.back()
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
              }
            })
        } else {
          return false
        }
      })
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .el-upload-list--picture-card .el-upload-list__item {
     width: 100px;
  height: 100px;
    line-height: 100px;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
   width: 100px;
  height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
   width: 100px;
  height: 100px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Version/Edit.vue